// Helper function to generate repeated array items for carousel
export const generateRepeatedItems = (items, repetitions = 5) => {
  return Array.from({ length: repetitions }, (_, repetitionIndex) =>
    items.map((item, itemIndex) => ({
      id: `${repetitionIndex}-${itemIndex}`,
      content: item
    }))
  ).flat();
};

// Helper function to format rating display
export const formatRating = (rating, reviews) => {
  return `${rating} (${reviews} Reviews)`;
};

// Helper function to format host names
export const formatHostNames = (hosts) => {
  if (hosts.length === 1) return hosts[0];
  if (hosts.length === 2) return `${hosts[0]} & ${hosts[1]}`;
  return hosts.slice(0, -1).join(', ') + ` & ${hosts[hosts.length - 1]}`;
}; 